import gql from 'graphql-tag';

const getCreditsConsumptionQuery = gql`
query getCreditsConsumption(
  $organisationId: String!, 
  $owner: String!, 
  $resourceType: String!, 
  $resourceToSearch: String!
) {
  getCreditsConsumption(
    organisationId: $organisationId,
    owner: $owner,
    resourceType: $resourceType,
    resourceToSearch: $resourceToSearch
  ) {
    resourceType
    consumedCredits
    searchTerm
    hasProjectSubmissionCredits
  }
}`;

export default ((organisationId) => ({
  query: getCreditsConsumptionQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: ({ owner, resourceType, resourceToSearch



  }) => ({
    organisationId,
    owner,
    resourceType,
    resourceToSearch
  })
}));